export default __webpack_public_path__ + "23d0715b798c348e61cf3f2252156e7c.png";